import React, { useEffect, useState } from "react";
import Api from "../../../services/api-service";
import Input2 from "../../../components/Entradas/Input2/index2";
import SearchIcon from "@material-ui/icons/Search";
import InputBusqueda from "../../../components/Table/inputBusqueda";
import Button from "../../../components/Button/index";
import Auth from "../../../services/auth-service.js";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Check from "../../../assets/img/check.png"
import Swal from "sweetalert2";
import {
  BarraBusqueda,
  BotonCrear,
  ContenedorTabla,
  ContenedorTitulo,
  Main,
  NavbarTabla,
  Th,
  Titulo,
  Tr,
  TablaDispo,
  TrC,
  IconoLupa,
  ContenedorDis,
  Nombredispositivo,
  DescripcionDispo,
  Organizacion,
  Tipo,
  ContenedorFecha,
  Tiempo,
  Fecha,
  BotonMostrar,
  BotonDatos,
  BotonDevice,
  BotonRetroceder2,
  BotonSiguiente2,
  Br,
} from "../AlertasElements";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "../../../components/Entradas/Select";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

const Index = () => {
  /*Dev lenin*/
  const [selTodos, setSelecTodos] = useState(null);
  const [nombreAlerta, setNombreAlerta] = useState("");
  const [postUnico, setUnico] = useState(null);
  const [postControl, setControll] = useState(false);
  const [postData, setDataa] = useState([]);
  const [valorOrganizacion, setValorOrganizacion] = useState();
  const [valorObjetvo, setValorObjeto] = useState([]);
  const [variablesPost, setVariablesPost] = useState([]);

  let history = useHistory();
  /* FIN*/

  const [arregloDispo, setArregloDispo] = useState([]);

  const [postOrganizaciones, setOrganizaciones] = useState([]);
  const [postHabilitaciones, setHabilitaciones] = useState([]);
  const [data, setData] = useState([]);
  const [newA, setNewA] = useState([]);
  const [nsd, setsd] = useState([]);
  const [postRol, setRol] = useState("");
  const [contro, setControl] = useState(false);
  const [selec, setSelec] = useState([true, false]);
  const query = new URLSearchParams(useLocation().search);
  const obteOrganizacion = query.get("organizacion");
  const obteLocalizacion = query.get("localizacion");

  function seleccionarTodos(e) {
    if (e.target.checked) {
      setSelecTodos(true)
    } else {
      setSelecTodos(false)
    }

  }

  function addDevices(e, i) {
    if (e.target.checked) {
      let as = []
      arregloDispo.push(i)
      setArregloDispo(arregloDispo)
      // const resultado = arregloDispo.push(i)
      // setArregloDispo(resultado)
    } else {
      const resultado = arregloDispo.filter(numbers => numbers != i);
      setArregloDispo(resultado)
    }
  }

  function envioParametros(e) {
    let arreglo = [];
    let Datos = {};
    setValorOrganizacion(e);
    postData.map((index) => {
      if (index.organizacion == obteOrganizacion) {
        index.localizacion.map((item) => {
          if (item.localiza == obteLocalizacion) {
            item.configuraciones.map((item2) => {
              if (
                item2.catalogo != null &&
                item2.catalogo != undefined &&
                item2.catalogo != ""
              ) {
                Datos = {};
                Datos.value = item2.catalogo;
                Datos.label = item2.nombre;
                arreglo.push(Datos);
                setControll(true);
              }
            })
          }
        })
        setValorObjeto(arreglo);
      }
    });
  }

  useEffect(async () => {
    Auth.saveAlert({})

    // setOrganizaciones(Auth.getOrganizaciones());

    let cotroles = await Auth.getOrganizaciones();
    cotroles.map((item) => {
      if (item.organizacion == obteOrganizacion) {
        let arreglo = [];
        let Datos = {};
        setUnico(item.organizacion);
        setValorOrganizacion(item.organizacion);
        item.localizacion.map((item1) => {
          if (item1.localiza == obteLocalizacion) {
            item1.configuraciones.map((item2) => {
              if (
                item2.catalogo != null &&
                item2.catalogo != undefined &&
                item2.catalogo != ""
              ) {
                Datos = {};
                Datos.value = item2.catalogo;
                Datos.label = item2.nombre;
                arreglo.push(Datos);
                setControll(true);
              }
            })
          }
        })
        setValorObjeto(arreglo);
      }
    })
    // if (cotroles.length == 1) {

    // } else {
    //   setDataa(cotroles);
    // }

    // setHabilitaciones(Auth.getHabilitations2());

    // let kobteOrganizacion = "epconst_gad_sto";
    let kobteOrganizacion = valorOrganizacion;
    Api.obtenerTESTING(postRol, kobteOrganizacion, obteLocalizacion).then(
      (respuesta) => {
        console.log('respuesta', respuesta)
        if (respuesta.status == true) {
          setData("");
        } else {
          setData(respuesta[0].dispositivos);
          setVariablesPost(respuesta[0].keys)
        }
      },
      (error) => { }
    );
  }, [postRol, selTodos]);

  function sendData() {
    let expre = /^[\w\s-_()]*$/

    let DOCUMENTO = {
      "nombre": "",
      "modulo": "",
      "mensajeTriiger": "",
      "messageThen": "l",
      "estado": true,
      "stateRepeat": false,
      "totalMinutes": 0,
      "totalMessage": 5,
      "condicionales": [],
      "connectors": [],
      "phones": [],
      "mails": [],
      "dispositivos": [],
      "organizacion": ""
    }
    console.log('selTodos', selTodos)
    console.log('arregloDispo', arregloDispo)
    if (!selTodos && arregloDispo.length <= 0) {
      Swal.fire("Debe Seleccionar algún dispositivo", "", "error");
    } else if (nombreAlerta == "") {
      Swal.fire("Debe Agregar un nombre", "", "error");
    }
    else {
      Auth.saveVariables(variablesPost)
      if (selTodos) {
        let dispositivosFinales = []
        data.map((index) => {
          let documento = {}
          documento.deviceID = index.dispositivo
          documento.auxwaitTrigger = ""
          documento.auxMessage = 0
          documento.stateNotified = true

          // dispositivosFinales.push(index.dispositivo)
          dispositivosFinales.push(documento)
        })

        DOCUMENTO.dispositivos = dispositivosFinales
        DOCUMENTO.modulo = postRol
        DOCUMENTO.organizacion = valorOrganizacion
        DOCUMENTO.nombre = nombreAlerta
        Auth.saveAlert(DOCUMENTO)
        Swal.fire("Guardado exitosamente", "", "success");
      } else {
        let dispositivosFinales2 = []
        arregloDispo.map((index) => {
          let documento = {}
          documento.deviceID = index
          documento.auxwaitTrigger = ""
          documento.auxMessage = 0
          documento.stateNotified = true
          // dispositivosFinales2.push(index.dispositivo)
          dispositivosFinales2.push(documento)
        })
        DOCUMENTO.dispositivos = dispositivosFinales2
        DOCUMENTO.modulo = postRol
        DOCUMENTO.organizacion = valorOrganizacion
        DOCUMENTO.nombre = nombreAlerta
        Auth.saveAlert(DOCUMENTO)
        Swal.fire("Guardado exitosamente", "", "success");
        //arregloDispo
      }

      let url = `/admin/createCondition?organizacion=${obteOrganizacion}&localizacion=${obteLocalizacion}`
      history.push(url);
    }

  }

  return (
    <>
      <Main>
        <ContenedorTitulo>
          <Titulo> Crear Alerta Grupo</Titulo>

        </ContenedorTitulo>
        <ContenedorTabla>
          <NavbarTabla>
            <Input2
              message="Nombre Grupo"
              value={nombreAlerta}
              setFunction={setNombreAlerta}
              id="outlined-disabled"
            />
            {postUnico == null ? (
              <Box
                component="form"
                sx={{
                  "& .MuiTextField-root": { m: 1, width: "30ch" },
                }}
                noValidate
                autoComplete="off"
              >
                <TextField
                  id="outlined-select-currency"
                  select
                  label="Seleccione organizacion"
                  value={valorOrganizacion}
                  onChange={(e) => envioParametros(e.target.value)}
                >
                  {postData.map((option) => (
                    <MenuItem
                      key={option.organizacion}
                      value={option.organizacion}
                    >
                      {option.nombre}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            ) : null}

            {postControl ? (
              <>
                {" "}
                <Select
                  message="Dispositivos"
                  value={postRol}
                  setFunction={setRol}
                  data={valorObjetvo}
                  id="outlined-disabled"
                />
              </>
            ) : null}
          </NavbarTabla>
          <div style={{ overflow: 'auto', width: '100%', height: 'auto', maxHeight: '20rem', WebkitOverflowScrolling: 'touch' }}>
            <TablaDispo>
              {data != "" ? (
                <>
                  <Tr>
                    <Th>Nombre</Th>
                    <Th>Dispositivo</Th>
                    <Th>Seleccionar<Checkbox onChange={(e) => seleccionarTodos(e)} /></Th>
                  </Tr>

                  {data.map((idnex) => (
                    <TrC>
                      <Th>{idnex.nombre}</Th>
                      <Th>{idnex.dispositivo}</Th>
                      <Th>
                        {selTodos ? <img src={Check} alt="MDN" style={{ "height": "40px" }} /> : <Checkbox onChange={(e) => addDevices(e, idnex.dispositivo)} />}

                      </Th>
                    </TrC>
                  ))}
                </>
              ) : null}
            </TablaDispo>
          </div>
        </ContenedorTabla>
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
          <Button url={`/admin/events?organizacion=${obteOrganizacion}&localizacion=${obteLocalizacion}`} message="Atras" style={BotonRetroceder2} />
          <BotonSiguiente2 onClick={() => sendData()}>Siguiente</BotonSiguiente2>
        </div>
      </Main>
    </>
  );
};
export default Index;
